export default __webpack_public_path__ + "static/media/gastrojobs.56647e18.jpg";